import type { FileNode } from "./types";

export async function fetchTree(): Promise<FileNode[]> {
  const res = await fetch("/api/files");
  const data = await res.json();
  return data.tree ?? [];
}

export async function fetchFileContent(path: string): Promise<string> {
  const res = await fetch(`/api/files/content?path=${encodeURIComponent(path)}`);
  if (!res.ok) throw new Error(`Failed to read ${path}`);
  const data = await res.json();
  return data.content;
}

export async function saveFileContent(path: string, content: string): Promise<void> {
  await fetch("/api/files/content", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ path, content }),
  });
}

export async function createEntry(path: string, type: "file" | "directory"): Promise<boolean> {
  const res = await fetch("/api/files", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ path, type }),
  });
  return res.ok;
}

export async function deleteEntry(path: string): Promise<boolean> {
  const res = await fetch(`/api/files?path=${encodeURIComponent(path)}`, { method: "DELETE" });
  return res.ok;
}
